<template>
  <div class="py-4 d-flex justify-content-center">
    <div class="w-100" style="max-width: 900px">
      <div class="card shadow-lg rounded">
        <div class="card-header text-black">
          <h5 class="mb-0">Send Notification</h5>
        </div>

        <div class="card-body">
          <form @submit.prevent="sendNotification">
            <!-- Title -->
            <div class="mb-3">
              <label class="form-label">Title</label>
              <input
                v-model="title"
                type="text"
                class="form-control"
                placeholder="Enter notification title"
                required
              />
            </div>

            <!-- Body -->
            <div class="mb-3">
              <label class="form-label">Body</label>
              <textarea
                v-model="body"
                class="form-control"
                placeholder="Enter notification body"
                rows="4"
                maxlength="300"
                style="resize: none"
                required
              ></textarea>
            </div>

            <!-- Language & Country -->
            <div class="row mb-3">
              <div class="col-md-6">
                <label class="form-label">Language</label>
                <select
                  v-model="selectedLang"
                  @change="onLangChange"
                  class="form-select"
                >
                  <option
                    v-for="lang in languages"
                    :key="lang.code"
                    :value="lang.code"
                  >
                    {{ lang.language }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label class="form-label">Country</label>
                <select
                  v-model="selectedCountry"
                  @change="onLangOrCountryChange"
                  class="form-select"
                >
                  <option value="" disabled>Select Country</option>
                  <option
                    v-for="country in countries"
                    :key="country.code"
                    :value="country.code"
                  >
                    {{ country.country }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Image Upload -->
            <div class="mb-3">
              <label class="form-label">Upload Image</label>
              <input
                type="file"
                ref="fileInput"
                class="form-control"
                @change="uploadImage"
                accept="image/*"
              />
            </div>

            <!-- Image Preview -->
            <div v-if="imageUrl" class="text-center mb-3">
              <img
                :src="imageUrl"
                class="img-fluid rounded"
                style="max-height: 200px"
              />
            </div>

            <!-- Submit -->
            <button
              type="submit"
              class="btn btn-primary w-100"
              :disabled="loading"
            >
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              <span>Send Notification</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../services/api";
import Cookies from "js-cookie";

export default {
  name: "SendNotification",

  data() {
    return {
      title: "",
      body: "",
      imageFile: null,
      imageUrl: "",
      loading: false,

      selectedLang: "",
      selectedCountry: "",

      languages: [],
      countries: [],
    };
  },

  async mounted() {
    await this.getLanguages();
    await this.loadCountries();
  },

  methods: {
    async getLanguages() {
      try {
        const response = await axios.get("languages", {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200 && Array.isArray(response.data.languages)) {
          this.languages = response.data.languages;
          this.selectedLang = this.languages[0]?.code || "";
        }
      } catch (error) {
        this.handleAuthError(error);
      }
    },

    async loadCountries() {
      try {
        const response = await axios.get("countries", {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200 && Array.isArray(response.data.countries)) {
          this.countries = response.data.countries;
          this.selectedCountry = this.countries[0]?.code || "";
        }
      } catch (error) {
        this.handleAuthError(error);
      }
    },

    onLangChange() {
      // hook if you need language-based logic later
    },

    onLangOrCountryChange() {
      // hook if you need combined logic later
    },

    uploadImage(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.imageFile = file;
      this.imageUrl = URL.createObjectURL(file);
    },

    async sendNotification() {
      try {
        this.loading = true;

        const formData = new FormData();
        formData.append("title", this.title);
        formData.append("body", this.body);
        formData.append("topic", this.selectedCountry);

        if (this.imageFile) {
          formData.append("file", this.imageFile);
        }

        const response = await axios.post("/sendnotification", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200) {
          this.$notify({
            message: response.data.message,
            type: "success",
          });

          // Reset form
          this.title = "";
          this.body = "";
          this.imageFile = null;
          this.imageUrl = "";
          this.$refs.fileInput.value = "";
        }
      } catch (error) {
        this.$notify({
          message: "Failed to send notification",
          type: "danger",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      } finally {
        this.loading = false;
      }
    },

    handleAuthError(error) {
      if (error?.response?.status === 401) {
        Cookies.remove("authToken");
        this.$router.push("/login");
      }

      this.$notify({
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error_message ||
          "Something went wrong",
        type: "danger",
        horizontalAlign: "right",
        verticalAlign: "top",
      });
    },
  },
};
</script>

<style scoped>
.card-header {
  padding: 0.75rem 1rem;
}
</style>
